import React from 'react';
import { faSitemap } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './SpecialtyProgButton.module.css';
import { CommonButton } from '_components';


export class SpecialtyProgButton extends React.Component {
    render() {
        let cls;
        cls = styles.button;

        if (this.props.className ) {
            cls += ' ' + this.props.className;
        }

        return (
            <CommonButton title={this.props.title ? this.props.title : 'Specialty Program Request'} onClick={this.props.onClick} size={this.props.size} className={cls} >
                <FontAwesomeIcon icon={faSitemap} transform={'shrink-6 left-1'} color="white" />
            </CommonButton>
        );
    }
}
